import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b062de8")

_pushScopeId("data-v-9b062de8")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "p-d-flex p-flex-column p-flex-md-row" }, null, -1)
const _hoisted_2 = { class: "p-d-flex p-flex-column p-flex-md-row p-jc-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "p-p-2",
  href: "https://swisslichens.wsl.ch/de/index.html",
  target: "_blank"
}, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-home" }),
  /*#__PURE__*/_createTextVNode(" Homepage SwissLichens")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("a", {
  class: "p-p-2",
  href: "mailto:swisslichens@wsl.ch",
  target: "_blank"
}, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-send" }),
  /*#__PURE__*/_createTextVNode(" swisslichens@wsl.ch")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Divider, { layout: "vertical" }),
      _hoisted_4
    ])
  ], 64))
})